import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=201c68aa"
import script from "./BaseFilter.vue?vue&type=script&lang=ts"
export * from "./BaseFilter.vue?vue&type=script&lang=ts"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=201c68aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports